import React from "react";
import RightMenu from "./RightMenu";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import DataTable from "./DataTable";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
  display: "flex",
  justifyContent: "space-between",
  height: 53,
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  height: "100%",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    // paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    // transition: theme.transitions.create("width"),
    // width: "100%",
    // [theme.breakpoints.up("md")]: {
    //   width: "20ch",
    // },
  },
  width: "100%",
}));

const CustomerSearch = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: 1079,
      }}
    >
      <div
        style={{
          width: 1019,
          marginTop: 15,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            background: "#FFF",
            minHeight: 592,
            width: 756,
          }}
        >
          <Search>
            <StyledInputBase
              placeholder="Search Customer"
              inputProps={{ "aria-label": "search" }}
            />
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
          </Search>
          <DataTable />
        </div>
        <RightMenu />
      </div>
    </div>
  );
};

export default CustomerSearch;
